<script setup>
import { ref } from 'vue';

defineProps({
  text: String,
});
const isOpen = ref(false);
const togglePopover = () => {
  isOpen.value = !isOpen.value;
};
const closePopover = () => {
  isOpen.value = false;
};
</script>

<template>
  <div class="relative inline-block" @click="togglePopover" @mouseover="togglePopover">
    <div class="cursor-pointer">
      <img src="@/assets/icons/info.svg" class="self-center" />
    </div>
    <div
      v-if="isOpen"
      class="absolute z-10 min-w-[110px] p-2 bg-white border border-gray-200 rounded-lg shadow-lg"
      @click.self="closePopover"
    >
      <p class="text-xs text-black text-normal">
        {{ text }}
      </p>
    </div>
  </div>
</template>
